const Footer = () => {
  return (
    <div className='copyright'>
      <h3 className='copyright__text'>JonKumar.netlify.app &#169; 2022</h3>
    </div>
  );
};

export default Footer;
